module.exports = new __parcel__URL__("ITSM Runbook Hover.69e2eef4.svg").toString();